import { metaAdsEndpoint, tiktokAdsEndpoint } from '@/config/endpoints';
import { RPostHogThrottle, posthogUTM } from '@/posthog';
import { getCookie } from '@/utils/getCookie';
import { getFbpFbcFromCookie } from '@/utils/getInfoFromCookie';
import { getAuth, User } from 'firebase/auth';
import { app } from '@/config/firebaseConfig';
import posthog from 'posthog-js';

const { utm } = posthogUTM();

export const reportLogin = async (
  user: User,
  loginWay: 'one-tap' | 'google-login' | 'email-login'
) => {
  const auth = getAuth(app);
  await auth.authStateReady();
  const authToken = auth.currentUser
    ? await auth.currentUser.getIdToken()
    : null;

  // 登录成功，修改本地 Person 数据
  posthog.identify(user.uid, {
    user_id: user.uid,
    email: user.email,
    user_identity: 3,
    login_way: loginWay,
    ...utm,
  });

  // posthog埋点
  RPostHogThrottle('login_kaze', {
    user_id: user.uid,
    email: user.email,
    user_identity: 3,
    login_way: loginWay,
    ...utm,
  });

  // gtag上报
  window?.gtag('set', 'user_data', {
    email: user.email || user.uid,
  });

  window?.gtag('event', 'conversion', {
    send_to: 'AW-16743758761/jai9COK77YEaEKn3hbA-',
  });

  // meta conversion
  await fetch(metaAdsEndpoint, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      ...getFbpFbcFromCookie(),
    },
    body: JSON.stringify({
      type: 'CompleteRegistration',
      email: user.email,
    }),
  });

  // tiktok ads
  await fetch(tiktokAdsEndpoint, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      Ttclid: new URLSearchParams(window.location.search).get('ttclid') || '',
      Ttp: getCookie('_ttp'),
    },
    body: JSON.stringify({
      type: 'CompleteRegistration',
      email: user.email,
    }),
  });
};
